import type { ContentPack } from '../types';
import { body_average } from './bodies/average';
import { body_slim } from './bodies/slim';
import { body_stocky } from './bodies/stocky';
import { body_chibi } from './bodies/chibi';
import { body_tall } from './bodies/tall';
import { hair } from './parts/hair';
import { faces } from './parts/faces';
import { tops } from './parts/tops';
import { bottoms } from './parts/bottoms';
import { shoes } from './parts/shoes';
import { hats } from './parts/hats';
import { CATEGORIES, STAT_DEFS } from './categories';
import { avatarComputeStats } from './stats';

const hulls = { body_average, body_slim, body_stocky, body_chibi, body_tall };
const parts = { ...hair, ...faces, ...tops, ...bottoms, ...shoes, ...hats };

export const avatarPack: ContentPack = {
  id: 'avatar',
  version: 1,
  metadata: {
    title: 'SPRITE: AVATARS',
    namingLabel: 'Avatar',
    filePrefix: 'sprite-avatar',
    baseCategoryId: 'hull', // 'body' category maps to 'hull' internally in avatarPack
  },
  colorLabels: { primary: 'Skin', accent: 'Accent', glow: 'Hair', detail: 'Pants', trim: 'Shoes' },
  rasterSize: 64,
  hulls,
  parts,
  categories: CATEGORIES,
  stats: STAT_DEFS,
  compositeSlots: {
    foot_pair: ['foot_left', 'foot_right'],
  },
  // hull is the body sentinel; everything else layers on top
  renderOrder: ['hull', 'bottom', 'shoes', 'top', 'hair', 'face', 'hat'],
  computeStats: avatarComputeStats,
  defaultBuild: {
    hull: 'body_average',
    hair: 'hair_short',
    face: 'face_happy',
    top: 'top_tshirt',
    bottom: 'bottom_pants',
    shoes: 'shoes_sneakers',
    hat: null,
  },
};
